import React, { createContext } from 'react'

export type PolicyDispatchingOfficeContextValue = {
  officeCode: string | null
  setOfficeCode: (officeCode: string | null) => void
}

let rememberedOfficeCode: string | null = null

export const getRememberedOfficeCode = () => rememberedOfficeCode

export const rememberOfficeCode = (officeCode: string | null) => {
  rememberedOfficeCode = officeCode
}

export const PolicyDispatchingOfficeContext = createContext<PolicyDispatchingOfficeContextValue | null>(null)

export const usePolicyDispatchingOffice = () => {
  const context = React.useContext(PolicyDispatchingOfficeContext)

  if (!context) {
    throw new Error('usePolicyDispatchingOffice must be used within PolicyDispatchingOfficeContext.Provider')
  }

  return context
}
